import React from "react";
import liftechImage from "../../Img/about-home-img.jpg";
import {
  ParkingCircle,
  Building2,
  Wrench,
  Leaf,
} from "lucide-react";

const HomeAbout = () => {
  return (
    <section className="lt-parking-section">
      <div className="lt-parking-left">
        <img
          src={liftechImage}
          alt="Liftech Parking Solutions"
          className="lt-parking-image"
        />
      </div>

      <div className="lt-parking-right">
        <p className="lt-parking-subtitle">🚗 Parking Solutions that Fit Every Space</p>
        <h2 className="lt-parking-title">LIFTECH ENGINEERING PVT. LTD.</h2>
        <p className="lt-parking-description">
          At LIFTECH, we specialize in innovative and space-efficient parking systems tailored for
          residential, commercial, and industrial needs. Our mission is to transform conventional
          parking into smarter, safer, and more convenient experiences using advanced engineering
          and automation technology.
        </p>

        <ul className="lt-parking-features">
          <li>
            <ParkingCircle className="lt-icon" />
            Automated and Semi-Automated Parking Systems
          </li>
          <li>
            <Building2 className="lt-icon" />
            Space-Saving Solutions for Residential & Commercial Buildings
          </li>
          <li>
            <Wrench className="lt-icon" />
            Low Maintenance, Durable, and Easy-to-Operate Designs
          </li>
          <li>
            <Leaf className="lt-icon" />
            Eco-Friendly Systems with Minimal Footprint
          </li>
        </ul>
      </div>
    </section>
  );
};

export default HomeAbout;
